import { ICreateItemFolhaPagamentoVerbaUseCase } from "../../../presentation/useCases/create/create_item_folha_pagamento_verba_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateItemFolhaPagamentoVerbaUseCase
 */

export class CreateItemFolhaPagamentoVerbaUseCase implements ICreateItemFolhaPagamentoVerbaUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createItemFolhaPagamentoVerba(
    idItemFolhaPagamento: number,
    idItensVerbaFuncionario: number[],
  ): Promise<void> {
    await this.repository.createItemFolhaPagamentoVerba(
      idItemFolhaPagamento,
      idItensVerbaFuncionario,
    );
  }
}
